import React from "react";
// import Front from "../home/front";
import PricingPlans from "../Plans/Plan";

const Planning = () => {
  return (
    <>
      {/* <Front /> */}
      <PricingPlans />
    </>
  );
};

export default Planning;
